import * as React from "react";

function SvgSuccess(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M8.854 13.813L8.5 13.46l-.354.353-2.833 2.833L4.96 17l.353.354 8.5 8.5.354.353.353-.353 15.111-15.112.354-.353-.354-.354-2.833-2.833-.354-.354-.353.354-11.924 11.924-5.313-5.313zM33.5 17c0 9.113-7.387 16.5-16.5 16.5S.5 26.113.5 17 7.887.5 17 .5 33.5 7.887 33.5 17z"
        fill="green"
        stroke="green"
      />
    </svg>
  );
}

export default SvgSuccess;
